import React from "react";
import { Page, Toolbar, BackButton } from "react-onsenui";
import TutorialCarousel from "../components/TutorialCarousel";

export default class TutorialPage extends React.Component {
  popPage() {
    this.props.navigator.popPage();
  }

  pushPage(page) {
    this.props.navigator.pushPage({
      component: page,
      props: {
        key: Math.random()
      }
    });
  }

  renderToolbar() {
    return (
      <Toolbar>
        <div className="left">
          <BackButton />
        </div>
        <div className="center">Tutorial</div>
      </Toolbar>
    );
  }
  render() {
    return (
      <Page renderToolbar={this.renderToolbar.bind(this)}>
        <div style={{ paddingTop: "50px" }}>
          <TutorialCarousel onFinish={this.popPage.bind(this)} />
        </div>
      </Page>
    );
  }
}
